'use client';

import { useContext } from 'react';

import { Turnstile, TurnstileProps } from '@marsidev/react-turnstile';

import { Captcha } from './captcha-provider';

export function CaptchaTokenSetter(props: {
  siteKey?: string;
  options?: Omit<TurnstileProps, 'siteKey' | 'onSuccess'>;
}) {
  const { setToken, setInstance } = useContext(Captcha);
  const siteKey = props.siteKey ?? process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY;

  if (!siteKey) {
    return null;
  }

  const options = props.options ?? {
    options: {
      size: 'invisible',
    },
  };

  const className = options.className ?? 'w-full';

  return (
    <Turnstile
      ref={(instance) => {
        if (instance) {
          setInstance(instance);
        }
      }}
      siteKey={siteKey}
      onSuccess={setToken}
      {...options}
      className={className}
    />
  );
}
